import { toPairs, filter, isNil, isEmpty } from 'ramda';

angular.module('tct.accountsService', ['tct.configService'])
  .factory('accountsService', accountsService);

accountsService.$inject = [
  'configService',
  '$http',
  'mappingService',
];

function accountsService(config, $http, mappingService) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/accounts`;
  const factory = {
    acceptUser,
    addUser,
    refuseUser,
    fetchReviewing,
    getAccountList,
    getClientAccounts,
    getNonClientAccounts,
    getEditorAccounts,
    resendAccountActivationEmail,
    editUser,
    removeUser,
  };

  return factory;

  function fetchReviewing(client) {
    const params = {};
    if (typeof client !== 'undefined') {
      params.client = client ? 'true' : 'false';
    }

    const url = `${basePath}/reviewing`;

    return $http.get(url, { params });
  }
  function acceptUser(user) {
    const url = `${basePath}/${user.id}/approve`;
    return $http.post(url);
  }
  function refuseUser(user, reason) {
    const payload = { reason: reason || '' };
    const url = `${basePath}/${user.id}/reject`;
    return $http.post(url, payload);
  }

  function addUser(user) {
    const url = `${basePath}/${user.type}`;

    return $http.post(url, mappingService.objectKeysToSnake(user));
  }

  function getClientAccounts(params) {
    return getAccounts(`${basePath}/clients`, params);
  }

  function getNonClientAccounts(params) {
    return getAccounts(`${basePath}/non-clients`, params);
  }

  function getEditorAccounts(params) {
    return getAccounts(`${basePath}/editors`, params);
  }

  function getAccounts(url, params) {
    const qParams = {};
    qParams['filters[name]'] = params.search.name;
    qParams['filters[company]'] = params.search.company;
    qParams['filters[roles]'] = params.search.roles;
    qParams['filters[status]'] = params.search.status;

    qParams.limit = params.limit;
    qParams.page = params.page;

    const sort = filter(pair => !isNil(pair[1]) && !isEmpty(pair[1]), toPairs(params.sort));
    if (sort.length > 0) {
      qParams.sort_by = sort[0][0];
      qParams.sort_dir = sort[0][1];
    }
    return $http.get(
      url,
      { params: qParams },
    );
  }

  function getAccountList(params) {
    let url = `${basePath}/`;
    if (params.isEditorView) {
      url += 'editors?';
    } else {
      url += (params.isClients) ? 'clients?' : 'non-clients?';
    }
    if (params.page.limit) url += `&limit=${params.page.limit}`;
    // if (params.page.limit) url += '&limit=2';
    if (params.search.name.length) url += `&filters[name]=${params.search.name}`;
    if (params.search.company.length) url += `&filters[company]=${params.search.company}`;
    if (params.search.status.length) url += `&filters[status]=${params.search.status}`;
    if (params.search.userType.length) url += `&filters[role]=${params.search.userType}`;
    // building sort query
    const sortKeys = Object.keys(params.sort);
    let sortQry = '';
    sortKeys.forEach((e) => {
      if (params.sort && params.sort[e] !== '') {
        sortQry = `&sort_by=${e}&sort_dir=${params.sort[e]}`;
      }
    });
    url = `${url}${sortQry}`;
    return $http.get(url);
  }

  function resendAccountActivationEmail(id) {
    const url = `${basePath}/${id}/activation/send`;

    return $http.put(url);
  }

  function editUser(user) {
    const url = `${basePath}/${user.id}`;
    return $http.put(url, mappingService.objectKeysToSnake(user));
  }

  function removeUser(userId) {
    const url = `${basePath}/${userId}`;
    return $http.delete(url);
  }
}
